"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwapErrorTypes = exports.SwapperType = exports.SwapperName = exports.SwapError = void 0;
const errors_1 = require("@shapeshiftoss/errors");
const types_1 = require("@shapeshiftoss/types");
exports.SwapError = (0, errors_1.createErrorClass)('SwapError');
var SwapperName;
(function (SwapperName) {
    SwapperName["Thorchain"] = "THORChain";
    SwapperName["Osmosis"] = "Osmosis";
    SwapperName["CowSwap"] = "CoW Swap";
    SwapperName["Zrx"] = "0x";
    SwapperName["Test"] = "Test";
})(SwapperName = exports.SwapperName || (exports.SwapperName = {}));
var SwapperType;
(function (SwapperType) {
    SwapperType["ZrxEthereum"] = "0xEthereum";
    SwapperType["ZrxAvalanche"] = "0xAvalanche";
    SwapperType["Thorchain"] = "Thorchain";
    SwapperType["Osmosis"] = "Osmosis";
    SwapperType["CowSwap"] = "CoW Swap";
    SwapperType["Test"] = "Test";
})(SwapperType = exports.SwapperType || (exports.SwapperType = {}));
// Swap Errors
var SwapErrorTypes;
(function (SwapErrorTypes) {
    SwapErrorTypes["ALLOWANCE_REQUIRED_FAILED"] = "ALLOWANCE_REQUIRED_FAILED";
    SwapErrorTypes["APPROVE_INFINITE_FAILED"] = "APPROVE_INFINITE_FAILED";
    SwapErrorTypes["APPROVE_AMOUNT_FAILED"] = "APPROVE_AMOUNT_FAILED";
    SwapErrorTypes["BUILD_TRADE_FAILED"] = "BUILD_TRADE_FAILED";
    SwapErrorTypes["CHECK_APPROVAL_FAILED"] = "CHECK_APPROVAL_FAILED";
    SwapErrorTypes["EXECUTE_TRADE_FAILED"] = "EXECUTE_TRADE_FAILED";
    SwapErrorTypes["GRANT_ALLOWANCE_FAILED"] = "GRANT_ALLOWANCE_FAILED";
    SwapErrorTypes["INITIALIZE_FAILED"] = "INITIALIZE_FAILED";
    SwapErrorTypes["MANAGER_ERROR"] = "MANAGER_ERROR";
    SwapErrorTypes["MIN_MAX_FAILED"] = "MIN_MAX_FAILED";
    SwapErrorTypes["RESPONSE_ERROR"] = "RESPONSE_ERROR";
    SwapErrorTypes["SIGN_AND_BROADCAST_FAILED"] = "SIGN_AND_BROADCAST_FAILED";
    SwapErrorTypes["TRADE_QUOTE_FAILED"] = "TRADE_QUOTE_FAILED";
    SwapErrorTypes["TRADE_QUOTE_AMOUNT_TOO_SMALL"] = "TRADE_QUOTE_AMOUNT_TOO_SMALL";
    SwapErrorTypes["TRADE_QUOTE_INPUT_LOWER_THAN_FEES"] = "TRADE_QUOTE_INPUT_LOWER_THAN_FEES";
    SwapErrorTypes["UNSUPPORTED_PAIR"] = "UNSUPPORTED_PAIR";
    SwapErrorTypes["USD_RATE_FAILED"] = "USD_RATE_FAILED";
    SwapErrorTypes["UNSUPPORTED_CHAIN"] = "UNSUPPORTED_CHAIN";
    SwapErrorTypes["UNSUPPORTED_NAMESPACE"] = "UNSUPPORTED_NAMESPACE";
    SwapErrorTypes["VALIDATION_FAILED"] = "VALIDATION_FAILED";
    SwapErrorTypes["MAKE_MEMO_FAILED"] = "MAKE_MEMO_FAILED";
    SwapErrorTypes["PRICE_RATIO_FAILED"] = "PRICE_RATIO_FAILED";
    SwapErrorTypes["POOL_NOT_FOUND"] = "POOL_NOT_FOUND";
    SwapErrorTypes["GET_TRADE_TXS_FAILED"] = "GET_TRADE_TXS_FAILED";
    SwapErrorTypes["TRADE_FAILED"] = "TRADE_FAILED";
})(SwapErrorTypes = exports.SwapErrorTypes || (exports.SwapErrorTypes = {}));
